export const CASE_CONFIG_REQUEST = "CASE_CONFIG_REQUEST";
export const CASE_CONFIG_RECEIVE = "CASE_CONFIG_RECEIVE";
export const CASE_CONFIG_FAILURE = "CASE_CONFIG_FAILURE";
export const RESET_CASE_CONFIG = "RESET_CASE_CONFIG";


export const REPORTING_GET_DSP_REQUEST = "REPORTING_GET_DSP_REQUEST";
export const REPORTING_GET_DSP_RECEIVE = "REPORTING_GET_DSP_RECEIVE";
export const REPORTING_GET_DSP_FAILURE = "REPORTING_GET_DSP_FAILURE";
export const RESET_REPORTING_GET_DSP = "RESET_REPORTING_GET_DSP";